"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slateHtmlSerializer = _interopRequireDefault(require("slate-html-serializer"));

var _slateEditorHtml = require("@canner/slate-editor-html");

var _slateReact = require("slate-react");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var serializer = new _slateHtmlSerializer.default({
  rules: _slateEditorHtml.DEFAULT_RULES
});

var _default = function _default() {
  return {
    /**
     * On paste, deserialize the HTML and then insert the fragment.
     *
     * @param {Event} event
     * @param {Change} change
     */
    onPaste: function onPaste(event, change) {
      var transfer = (0, _slateReact.getEventTransfer)(event);
      if (transfer.type != "html") return;

      var _serializer$deseriali = serializer.deserialize(transfer.html),
          document = _serializer$deseriali.document;

      change.insertFragment(document);
      return true;
    }
  };
};

exports.default = _default;